<template>
  <div>
    <div class="m-b-10">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe :src="source" allowfullscreen=""></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "story-peertube-player",
  props: {
    source: {
      type: String,
    },
  },
};
</script>
